import React, { useRef, useEffect, useState } from "react";
import { shallowEqual, useSelector, connect, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "./authRedux";
import { getUserByToken } from "./authCrud";

function AuthInit(props) {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [connectionError, setConnectionError] = useState(false);
  const { authToken } = useSelector(
    ({ auth }) => ({
      authToken: auth.authToken
    }),
    shallowEqual
  );

  // We should request user by authToken before rendering the application
  const requestUser = async () => {
    setConnectionError(false);
    try {
      if (!didRequest.current) {
        const { data: user } = await getUserByToken();
        dispatch(props.fulfillUser(user));
      }
      setShowSplashScreen(false);
    } catch (error) {
      console.error(error);
      // Only a real 401 ends the session; a timeout/offline/5xx keeps the token and offers a retry.
      if (error.response && error.response.status === 401) {
        if (!didRequest.current) {
          dispatch(props.sessionEnded());
        }
        setShowSplashScreen(false);
      } else {
        setConnectionError(true);
      }
    }
  };

  useEffect(() => {
    if (authToken) {
      requestUser();
    } else {
      dispatch(props.fulfillUser(undefined));
      setShowSplashScreen(false);
    }
    return () => {
      didRequest.current = true;
    };
    // eslint-disable-next-line
  }, []);

  if (connectionError) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-10" style={{ minHeight: "100vh" }}>
        <h4 className="mb-3">Can't reach ANIKE</h4>
        <p className="text-muted mb-6">Check your connection and try again. You are still signed in.</p>
        <button type="button" className="btn btn-primary" onClick={requestUser}>Retry</button>
      </div>
    );
  }

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
}

export default connect(null, auth.actions)(AuthInit);
